import { NumberFormatter, formatNumber } from "@/uiCore";
import { Badge } from "@altimateai/lego";
import { TooltipProps } from "recharts";
import classNames from "classnames";
import { useAppState } from "@/modules/app/useAppContext";

export const SAVINGS_PIE_COLORS = ["#0088FE", "#00C49F"];

export interface SavingsPieData {
  total: number;
  autonomous: number;
  assisted: number;
}

type Props = TooltipProps<number, string> & { data: SavingsPieData };

const SavingsPieTooltip = ({ active, payload, data }: Props) => {
  const { currency } = useAppState();

  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div className={classNames("custom-tooltip bg-white px-2 py-1 border-4 rounded")}>
      <Badge variant="warning" className="mb-2">
        Total Savings:
        <NumberFormatter options={{ currency }} value={data.total} />
      </Badge>
      <p>
        <span className="px-2 rounded me-1" style={{ background: SAVINGS_PIE_COLORS[0] }} />
        Autonomous:
        {formatNumber(data.autonomous, { currency })}
      </p>
      <p>
        <span className="px-2 rounded me-1" style={{ background: SAVINGS_PIE_COLORS[1] }} />
        Assisted:
        {formatNumber(data.assisted, { currency })}
      </p>
    </div>
  );
};

export default SavingsPieTooltip;
